<template lang="pug">
  .fpui-progress-bar
    .fpui-progress-bar-content(:style="contentStyle") {{text}}
</template>

<script>
  export default {
    props:{
      text:String,
      percent:Number,
      color:String
    },
    computed:{
      contentStyle() {
        return {
          width:(100*this.percent)+'%',
          backgroundColor:this.color
        }
      }
    }
  }
</script>
